export default __webpack_public_path__ + "static/lineto-circular-book-5b0e4a984d88022c145a2bfe1d607a26.woff2";